export function IndeterminateCheckboxDirective() {
    return {
        require: "?ngModel",
        restrict: "A",
        link: link
    };

    function link(scope, el, attr, ctrl) {
        ctrl.$formatters = [];
        ctrl.$parsers = [];
        ctrl.$render = function () {
            const d = ctrl.$viewValue;
            el.data('checked', d);
            switch (d) {
                case true:
                    el.prop('indeterminate', false);
                    el.prop('checked', true);
                    break;
                case false:
                    el.prop('indeterminate', false);
                    el.prop('checked', false);
                    break;
                default:
                    el.prop('indeterminate', true);
            }
        };
        el.bind('click', function () {
            let d;
            switch (el.data('checked')) {
                case false:
                    d = true;
                    break;
                case true:
                    d = null;
                    break;
                default:
                    d = false;
            }
            ctrl.$setViewValue(d);
            scope.$apply(ctrl.$render);
        });

        ctrl.$formatters.push(function setIndeterminate(modelValue) {
            el.prop("indeterminate", modelValue == null);
            return modelValue;
        });
    }
}
